import { PREPROD_CONFIGS, PROD_CONFIGS, QA_CONFIGS } from './env-config';

export const BUILD = process.env.REACT_APP_BUILD;

let ENV_CONFIG = QA_CONFIGS;
if (BUILD === 'prod') ENV_CONFIG = PROD_CONFIGS;
else if (BUILD === 'preprod') ENV_CONFIG = PREPROD_CONFIGS;

// Get details from local Configs
export const RELEASE = ENV_CONFIG.RELEASE;
export const BE_BASE_URL = ENV_CONFIG.BASE_URL;
export const API_URL = BE_BASE_URL + 'v1';
export const API_URL_V2 = BE_BASE_URL + 'v2';
export const API_URL_V3 = BE_BASE_URL + 'v3';
export const API_URL_V4 = BE_BASE_URL + 'v4';
export const REQ_TIMEOUT = ENV_CONFIG.TIMEOUT;
export const VISION_CHECK_COUNT_LIMIT = ENV_CONFIG.VISION_CHECK_COUNT_LIMIT;
export const SME_URL = ENV_CONFIG.SME_URL;
export const GTM_ID = ENV_CONFIG.GTM_ID;
export const FLAGSMITH_URL = ENV_CONFIG.FLAGSMITH_URL;
export const PUBLIC_PATH = process.env.PUBLIC_URL;
